// https://swiperjs.com/react
import React, { Children, cloneElement, useRef } from "react";
import { useBreakpoints } from "~hooks";
import cn from "classnames";
import { SVG } from "~components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from "swiper";
import "swiper/css/bundle";
import * as styles from "./styles.module.scss";

const SwiperCarousel = ({
  children,
  className,
  slidesPerView = 1,
  fullSpace,
  navigation,
  spaceBetween,
  heading
}) => {
  const childrenArray = Children.toArray(children);

  const prevRef = useRef();
  const nextRef = useRef();

  const breakpoints = useBreakpoints();
  const swiperCardMargin = breakpoints.smallDesktop ? 40 : 16; // Matches x-padding from WidthContainer

  const showNavButtons = navigation && childrenArray.length > slidesPerView;

  return (
    <>
      {heading && (
        <div className={styles.titleAndControls}>
          <h2 className={cn(`h2`, styles.heading)}>{heading}</h2>
          {showNavButtons && (
            <button
              type="button"
              className={styles.navButton}
              ref={prevRef}
              aria-label="Previous slide"
            >
              <SVG svg="arrowLeft" />
            </button>
          )}
          {showNavButtons && (
            <button
              type="button"
              className={styles.navButton}
              ref={nextRef}
              aria-label="Next slide"
            >
              <SVG svg="arrowRight" />
            </button>
          )}
        </div>
      )}
      <Swiper
        onInit={(swiper) => {
          if (!navigation) return;
          swiper.params.navigation.prevEl = prevRef.current;
          swiper.params.navigation.nextEl = nextRef.current;
          swiper.navigation.init();
        }}
        spaceBetween={spaceBetween || swiperCardMargin}
        slidesPerView={slidesPerView}
        modules={[Pagination, Navigation]}
        pagination={{
          el: `.custom-pagination`,
          clickable: true,
          renderBullet: (_i, bulletClass) =>
            `<div class="${bulletClass}"></div>`
        }}
        className={cn(styles.carousel, className, {
          [styles.fullSpace]: fullSpace
        })}
      >
        {Children.map(childrenArray, (child, i) => (
          <SwiperSlide key={i}>{cloneElement(child)}</SwiperSlide>
        ))}
        <div className={cn(`custom-pagination`, styles.pagination)} />
      </Swiper>
    </>
  );
};

export default SwiperCarousel;
